import formatDate from '../../lib/format_date';

$(() => {
  $('.js-photo-upload-container').on('change', '.js-upload-input', el => {
    const file = el.currentTarget.files[0];
    const $uploadInput = $(el.currentTarget);

    if (el.currentTarget.files.length === 0) {
      return;
    }

    if (file.size > 8 * 1024 * 1024) {
      alert('8MBより大きい画像はアップロードできません');
      return;
    }

    if (!/^image\/\w+$/.test(file.type)) {
      alert('画像ファイルを選択して下さい。');
      return;
    }

    const $container = $uploadInput.closest('.js-photo-upload-container');
    const fileReader = new FileReader();

    fileReader.onload = e => {
      $container.find('.js-photo-preview img').attr({ src: e.target.result });
      $container.find('.js-photo-details').hide();
      $container.find('.js-photo-preview').show();

      if ($container.find("input[name='photo[crop_x]']").length !== 0) {
        $uploadInput.hide();
        $container.find('img').cropper({
          aspectRatio: 4 / 3,
          autoCropArea: 1,
          zoomable: false,
          viewMode: 1,
          dragMode: 'crop',
          minContainerWidth: 480,
          minContainerHeight: 360,
          rotatable: true,
          checkOrientation: true,
          crop(ev) {
            $container.find("input[name='photo[crop_x]']").val(ev.detail.x);
            $container.find("input[name='photo[crop_y]']").val(ev.detail.y);
            $container.find("input[name='photo[crop_width]']").val(ev.detail.width);
            $container.find("input[name='photo[crop_height]']").val(ev.detail.height);
          },
        });
      }

      const fileNameInput = $container.find('.js-photo-name');

      if (fileNameInput.is(':empty')) {
        let name = file.name.replace(/\.[^.]+$/, '');
        if (name.length > 20) {
          name = formatDate();
        }
        fileNameInput.val(name);
      }
    };

    fileReader.readAsDataURL(file);
    $container.find("input[type='file']").click(() => false);
  });

  // 写真アップロード時の処理
  $('.js-photo-upload-container').on('ajax:success', '.js-upload-photo-modal form', (e, data) => {
    if (data.error_message) {
      // FIXME ajax:errorで拾いたい
      alert(data.error_message);
      return;
    }
    const $form = $(e.currentTarget);
    const target = $($form.data('target'));
    target.find('.js-photo-id').val(data.id);
    target.find('.js-selected-photo img').attr('src', data.src).show();
    $form.closest('.js-upload-photo-modal').modal('hide');
  });

  // ロゴアップロード時の処理
  $('.js-photo-upload-container').on('ajax:success', '.js-upload-logo-modal form', (e, data) => {
    if (data.error_message) {
      // FIXME ajax:errorで拾いたい
      alert(data.error_message);
      return;
    }
    const $form = $(e.currentTarget);
    $('.js-logo-id').val(data.id);
    $('.js-selected-logo').removeClass('unselected');
    $('.js-selected-logo img').attr('src', data.src).show();
    $form.closest('.js-upload-logo-modal').modal('hide');
  });
});
